import {
  viandas2Get,
  viandas2Post,
  viandas2Put,
  viandas2Delete,
} from "../../../common/service/viandas2Client";
import { getPedidosRRHH } from "../../pedidos/service/pedidosRRHHService";

// Menús disponibles para la sucursal del usuario elegido (no la del que está logueado).
export const getDisponiblesUsuario = (username, desde, hasta) =>
  viandas2Get(`/rrhh/disponibles/${username}`, { desde, hasta });

// Reusa el endpoint de reportes de pedidos RRHH, filtrado por ese username.
export const getPedidosUsuario = (username, desde, hasta) =>
  getPedidosRRHH({ username, desde, hasta });

export const crearPedidoUsuario = (username, id_menu, fecha) =>
  viandas2Post("/rrhh/pedidos", { username, id_menu, fecha });

export const actualizarPedidoUsuario = (id, id_menu) =>
  viandas2Put(`/rrhh/pedidos/${id}`, { id_menu });

export const cancelarPedidoUsuario = (id) => viandas2Delete(`/rrhh/pedidos/${id}`);
